module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAwCAYAAADUxsC8AAAAAXNSR0IArs4c6QAAADlJREFUKFNjdNzF+J8BChiHJidwJ+N3uBf+r2S8j8xBeO7/SiSfDnIOwgsiZYcRnmMovIzwz5DkAAB4025Z7JW81QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/shj/sant.png
// module id = XIFU
// module chunks = 0